export default __webpack_public_path__ + "static/media/cell highlight.4d32d80b.jpg";